import { RefObject, useEffect, useRef } from 'react';

/**
 * Hook used to determine if the parent component is still mounted.
 * Returns a boolean ref object that will have its current value
 * set to `false` when the parent component is unmounted.
 */
export function useIsMounted(): RefObject<boolean> {
    const isMountedRef = useRef(true);

    useEffect(() => {
        // This is to re-init the mounted state on module reload
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    return isMountedRef;
}
